import React from 'react';
import { AnimateBlock, BlockHeader } from '../../components';
import { Col, Row } from '../../grid';
import { block } from '../../utils';
import './CardLayout.css';
const DEFAULT_SIZES = {
    all: 12,
    sm: 6,
    md: 4,
};
const b = block('card-layout-block');
const CardLayout = ({ title, description, animated, colSizes = DEFAULT_SIZES, children, }) => (React.createElement(AnimateBlock, { className: b(), animate: animated },
    (title || description) && React.createElement(BlockHeader, { title: title, description: description }),
    React.createElement(Row, null, React.Children.map(children, (child, index) => (React.createElement(Col, { key: index, sizes: colSizes, className: b('item') }, child))))));
export default CardLayout;
